import React from 'react';
import config from '../../helpers/config';
import { Helmet } from 'react-helmet';

export default (props) => {
    return (
        <Helmet>
            <title>{`咪寶產後護理之家 - ${props.name}`}</title>3
            <meta property="og:title" content={`咪寶產後護理之家 - ${props.name}`} />
            <meta property="og:url" content={`${config.host}${props.linkUrl}`} />
            <meta property="og:image" content={`${config.S3Endpoint}${props.imgUrl}`} />
            <meta property="og:description" content={`${props.desc}`} />
        </Helmet>
    )
}


// WEBPACK FOOTER //
// ./src/client/components/Helmet.js